// App
import App from './app/App.js';

/* global baseUrl, debug */
var app = new App(baseUrl, debug);
app.start();